<template>
    <div>
        <div class="flex flex-col">
            <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-5 flex justify-between items-center px-4 py-5 sm:px-6">
                <h3 class="text-lg font-medium text-gray-900 leading-10">{{ title }}</h3>
                <div class="flex items-center space-x-4">
                    <Search />
                    <PrivateDocumentUploadButton 
                        :attachable-type="modelType"
                        :attachable-id="modelId"
                        v-if="!documentsStore.isSearch && documentsStore.canInteractWithTable"
                    />
                    <button v-if="!documentsStore.isSearch && documentsStore.canInteractWithTable" @click="handleCreateFolderClick" class="cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:w-auto sm:text-sm">
                        Create a folder
                    </button>
                    <FolderCreateModal 
                        :attachable-id="modelId" 
                        :attachable-type="modelType"
                        :open="isCreateFolderModalOpen" 
                        @close="handleCloseCreateFolderModal" 
                        v-if="documentsStore.canInteractWithTable"
                    />
                </div>
            </div>

            <div class="-my-2 sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <file-system-sortable-table 
                            v-if="documentsStore.root.content.length > 0 && !documentsStore.isSearch" 
                            :folder="documentsStore.root"
                            :show-root="true"
                        />
                        <document-search-table 
                            v-else-if="documentsStore.searchResults.length > 0 && documentsStore.isSearch"
                        />
                        <tr v-else>
                            <td class="px-6 py-4 whitespace-nowrap">
                                <div class="flex items-center px-0.5">
                                    No attachments available!
                                </div>
                            </td>
                        </tr>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PrivateDocumentUploadButton from './PrivateDocumentUploadButton.vue';
import FolderCreateModal from './FolderCreateModal.vue';
import Search from './Search.vue';
import DocumentSearchTable from './DocumentSearchTable.vue';
import { mapStores } from 'pinia';
import { useDocumentsStore } from '../../stores/documentsStore';
import { document } from 'postcss';

export default {
    name: "file-system-table",
    display: "File System Table",
    components: {
        PrivateDocumentUploadButton,
        FolderCreateModal,
        Search,
        DocumentSearchTable
    },
    props: {
        title: {
            type: String,
            required: true
        },
        modelId: {
            type: Number,
            required: true
        },
        modelType: {
            type: String,
            required: true
        },
        caninteract: {
            type: Boolean,
            required: false
        },
    },
    computed: {
        ...mapStores(useDocumentsStore)
    },
    data() {
        return {
            content: {},
            isCreateFolderModalOpen: false,
            document: {
                id: 1,
                created_at: '2021-09-01',
                created_by: 'John Doe',
                metadata: 
                    {
                        name: 'Document 1',
                        size: '1200',
                        file_type: 'pptx',
                        download_url: 'https://www.google.com'
                    }
            },
            folder: {
                id: 1,
                name: 'Folder 1'
            }
        }
    },
    calculated: {
        isContentEmpty() {
            return Object.keys(this.content).length === 0;
        }
    },
    methods: {
        handleCreateFolderClick(){
            this.isCreateFolderModalOpen = true;
        },
        handleCloseCreateFolderModal(){
            this.isCreateFolderModalOpen = false;
        }
    },
    mounted() {
        this.documentsStore.setAttachableId(this.modelId);
        this.documentsStore.setAttachableType(this.modelType);
        this.documentsStore.setCanInteractWithTable(this.caninteract);
        this.documentsStore.fetchAllContent();
    }
}

</script>